module.exports = __webpack_public_path__ + "static/img/7.7ab3483.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/7.png
// module id = pGGV
// module chunks = 1